import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';

/** Get the Enquiry Lists*/
interface useEnquiryProps {
  orgId?: string;
  listingId?: string;
  enquiryId: string;
}
export const useEnquiry = ({
  orgId: overrideOrgId,
  listingId,
  enquiryId,
}: useEnquiryProps) => {
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);
  const orgId = overrideOrgId || activeBuyerOrgId;
  return useQuery(
    [QUERY_KEYS.enquiry, listingId, enquiryId],
    () =>
      new ApiClient().EnquiryApi.orgMarketplaceListingEnquiryRetrieve({
        listingId: listingId || '',
        buyerOrgId: orgId as string,
        listingEnquiryId: enquiryId,
      }),
    {
      select: (data) => data.data,
      enabled: !!listingId && !!orgId && !!enquiryId,
    }
  );
};
